import { createStore } from 'vuex'
import { login, logout, getInfo } from '@/api/user'

export default createStore({
  state: {
    userInfo: null
  },
  mutations: {
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    CLEAR_USER_INFO: (state) => {
      state.userInfo = null
    }
  },
  actions: {
    // 登录
    Login(_, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          const user = res.data
          if (user) {
            commit('SET_USER_INFO', user)
            resolve(user)
          } else {
            reject(new Error('获取用户信息失败'))
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut({ commit }) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          commit('CLEAR_USER_INFO')
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  modules: {
  }
})
